import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * AdminRoute component that restricts access to admin users only
 * Redirects to admin login if user is not authenticated
 * Redirects to dashboard if user is authenticated but not an admin
 */
const AdminRoute = ({ children }) => {
  const { isAuthenticated, hasRole, loading, user } = useAuth();
  const location = useLocation();

  // Show loading state while authentication state is being determined
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Redirect to admin login if not authenticated
  if (!isAuthenticated()) {
    return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  }

  // Redirect to dashboard if authenticated but not admin
  if (!hasRole('admin')) {
    return <Navigate to="/dashboard" replace />;
  }

  // Render children if authenticated and admin
  return children;
};

export default AdminRoute;
